import React from "react";
import { MDBBtn, MDBInput, MDBSpinner, MDBIcon } from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import logoImg from "images/cuberite-logo.png";
import "./MFMLoginScreen.css";

export default class MFMLoginScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loading: false,
      error: null,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value, error: null });
  };

  doLogin = (e) => {
    e.preventDefault();
    const { username, password } = this.state;

    if (!username || !password) {
      this.setState({ error: "Introduce usuario y contraseña." });
      return;
    }

    const base64Credentials = btoa(username + ":" + password);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Basic " + base64Credentials,
        "Content-Type": "application/json",
      },
    };

    this.setState({ loading: true, error: null });

    doFetch("SSO", "login", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && (data.STATE === "OK" || data.STATE === "SUCCESS")) {
          this.props.onLoggedIn(true);
        } else {
          this.setState({
            error: data?.MESSAGE || "Credenciales incorrectas.",
          });
        }
      })
      .catch((err) => {
        console.error("[MFM-LOGIN] Error:", err);
        this.setState({ error: "Error de conexión. Inténtalo de nuevo." });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { username, password, loading, error } = this.state;

    return (
      <div className="mfm-login-screen">
        <div className="mfm-login-card">
          <div className="mfm-login-header">
            <img src={logoImg} alt="Cuberite" className="mfm-login-logo" />
            <div className="mfm-login-app-name">
              <MDBIcon fas icon="photo-film" className="mfm-login-icon" />
              <span>Media File Manager</span>
            </div>
          </div>
          <form onSubmit={this.doLogin}>
            <MDBInput
              className="mb-3"
              type="text"
              id="username"
              label="Usuario"
              value={username}
              onChange={this.handleChange}
              disabled={loading}
            />
            <MDBInput
              className="mb-4"
              type="password"
              id="password"
              label="Contraseña"
              value={password}
              onChange={this.handleChange}
              disabled={loading}
            />
            {error && <p className="mfm-login-error">{error}</p>}
            <MDBBtn type="submit" block disabled={loading}>
              {loading && <MDBSpinner size="sm" className="me-2" />}
              Iniciar sesión
            </MDBBtn>
          </form>
        </div>
      </div>
    );
  }
}
